import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { loadStreamThunk } from "@common/redux/slices/streams.slice";
import { SingleStream } from "@kursk/components/pages/SingleStream/SingleStream";
import { loadRecommendationsForStreams } from "@common/redux/slices/recommendation.slice";

export default function Stream({ notFound }) {

  if (notFound) {
    return (<NotFoundPage/>);
  }
  return <SingleStream/>;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, params }) => {
  const { id } = params;

  await Promise.all([
    store.dispatch<any>(loadRecommendationsForStreams({ id: id })),
    store.dispatch<any>(loadStreamThunk({ id: id })),
  ]);

  const stream = store.getState().streamsList.stream;

  if (!stream?._id) {
    return {
      props: { notFound: true }
    };
  }
});
